import { QUERY_KEYS } from "@/libraries/constant";
import type { BulletinGroup, ResError } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useBulletinMutation() {
	const subscribe = useMutation<unknown, ResError, BulletinGroup["id"][]>({
		mutationKey: [QUERY_KEYS.MUTATE_BULLETIN_SUBSCRIBE],
	});

	return {
		subscribe,
	};
}

export default useBulletinMutation;
